import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import { Link } from "react-router-dom";
import Language from "../RightNavbarMenu/RightNavbarMenu";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedDoctor, setSelectedRole } from "../../store/slices/authSlice";
import { useState } from "react";
import { Dialog } from "primereact/dialog";
import { MdLocationOn, MdPersonOutline, MdTune } from "react-icons/md";

const selectClass =
    "w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:border-[#12AB81] appearance-none";
const labelClass = "block text-xs font-semibold text-gray-500 mb-1.5";

const Header = () => {
    const { userRoles, selectedRole, selectedDoctor } = useSelector((state: any) => state.auth);
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [draftRole, setDraftRole] = useState<any>(null);
    const [draftDoctor, setDraftDoctor] = useState<any>(null);

    const openModal = () => {
        setDraftRole(selectedRole);
        setDraftDoctor(selectedDoctor);
        setShowModal(true);
    };

    const handleSelectRole = (value: any) => {
        const role = JSON.parse(value);
        setDraftRole(role);
        setDraftDoctor(role?.parentUsers?.length > 0 ? role.parentUsers[0] : null);
    };

    const handleSelectDoctor = (value: any) => {
        setDraftDoctor(JSON.parse(value));
    };

    const handleDone = () => {
        dispatch(setSelectedRole(draftRole));
        dispatch(setSelectedDoctor(draftDoctor));
        setShowModal(false);
    };

    const locationLabel = selectedRole?.location?.name
        ? `${selectedRole.location.name}${selectedRole.location.organization?.name ? ` · ${selectedRole.location.organization.name}` : ''}`
        : 'Select location';

    const doctorLabel = selectedDoctor?.name || 'Select doctor';

    return (
        <>
            <header className="w-full bg-white border-b border-gray-200 shadow-sm">
                {/* Row 1: Brand + Avatar */}
                <div className="flex items-center justify-between px-4 py-2.5">
                    <Link to="/">
                        <p className="text-lg font-extrabold text-green-500 tracking-tight">Shafa Care</p>
                    </Link>
                    <Language />
                </div>

                {/* Row 2: Compact context bar */}
                <div className="flex items-center gap-2 px-4 pb-2.5">
                    {/* Location */}
                    <div className="flex items-center gap-1 min-w-0 flex-1">
                        <MdLocationOn size={13} className="text-[#12AB81] flex-shrink-0" />
                        <span className="text-xs text-gray-500 truncate">{locationLabel}</span>
                    </div>

                    {/* Divider */}
                    {selectedDoctor?.name && (
                        <>
                            <span className="text-gray-200 flex-shrink-0">|</span>
                            {/* Doctor */}
                            <div className="flex items-center gap-1 min-w-0 flex-1">
                                <MdPersonOutline size={13} className="text-[#12AB81] flex-shrink-0" />
                                <span className="text-xs text-gray-500 truncate">{doctorLabel}</span>
                            </div>
                        </>
                    )}

                    {/* Change button */}
                    <button
                        aria-label="Change location or doctor"
                        className="flex-shrink-0 p-1.5 rounded-lg active:bg-gray-100 ml-1"
                        onClick={openModal}
                    >
                        <MdTune size={17} className="text-[#12AB81]" />
                    </button>
                </div>
            </header>

            {/* Change Location & Doctor Modal */}
            <Dialog
                visible={showModal}
                style={{ width: "90vw", maxWidth: "380px" }}
                header="Change Location & Doctor"
                onHide={() => setShowModal(false)}
            >
                <div className="space-y-4 pt-1">
                    {/* Location select */}
                    {userRoles?.length > 0 && (
                        <div>
                            <label className={labelClass}>Location</label>
                            <select
                                className={selectClass}
                                value={JSON.stringify(draftRole)}
                                onChange={(e) => handleSelectRole(e.target.value)}
                            >
                                {userRoles.map((data: any, index: number) => (
                                    <option key={index} value={JSON.stringify(data)}>
                                        {data?.location?.name}, {data?.location?.organization?.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Doctor select */}
                    {draftRole?.parentUsers?.length > 0 && (
                        <div>
                            <label className={labelClass}>Doctor</label>
                            <select
                                className={selectClass}
                                value={JSON.stringify(draftDoctor)}
                                onChange={(e) => handleSelectDoctor(e.target.value)}
                            >
                                {draftRole.parentUsers.map((data: any, index: number) => (
                                    <option key={index} value={JSON.stringify(data)}>
                                        {data?.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Done */}
                    <button
                        className="w-full py-3 bg-[#12AB81] text-white rounded-xl font-semibold text-sm active:opacity-80 mt-2"
                        onClick={handleDone}
                    >
                        Done
                    </button>
                </div>
            </Dialog>
        </>
    );
};

export default Header;
